import React from 'react'

import { ImageIcon } from 'lucide-react'

import { Skeleton } from '~/client/src/shared/components/shadcn-ui/skeleton'

import './PhotoThumbnail.scss'

export default class PhotoThumbnail extends React.Component {
  public render() {
    return (
      <Skeleton className="thumbnail-container tw:items-center tw:justify-center">
        <ImageIcon className="tw:size-6 tw:text-muted-foreground" />
      </Skeleton>
    )
  }
}
